import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Due to limited capabilities of traditional methods to reflect the depth of experiential qualities associated with spatial hearing, a more advanced, custom methodologies have been proposed. One example is ADA method (developed by Dolby [No]) that allows high dimensional capture of subjective experiences of sound localization and quality. In this section one of a basic application of ADA method is presented - evaluation of binaural audio systems performance in the context of spatial localization.<br><br>Below a sample visualization of results from ADA methodology is presented. In this case, the test was designed to capture the perceived location and dispersion of a stimuli across three different binaural technologies. A listener was instructed to record responses on a ring (at fixed distance) in a dedicated application to represent angle and dispersion. However, please note that unlike the true ADA test, which is conducted in a dedicated test room, this example does not allow you to specify the height (angle of elevation), dispersion of the sound source, and distance (which is fixed here).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/02/26/principle/slide6-figure1.svg`,
              styles: {
                height: "50%",
              },
            },
          },
        },
      },
    },
  },
};

export default principle;
